import React from 'react';
import { StyledTextArea } from '@components/text-area/styled.tsx';
import type { TextAreaProps } from 'antd/es/input';

export const BaseTextArea: React.FC<TextAreaProps> = (props) => <StyledTextArea {...props} />;
